import { useDispatch } from "react-redux"
import { selectView } from "redux/actions/customers/customersAction"

export const useHandleView = (count) => {
  const dispatch = useDispatch()
  
  const handleRun = () => {
    dispatch(selectView(-1))
    setTimeout(() => {
      dispatch(selectView(count))
    }, 500);
  }

  return handleRun
}